<app-spinner></app-spinner>
<app-header *ngIf="(router.url !== '/viewPdf') || (!router.url.includes('/trz'))"></app-header>
<main *ngIf="router.url !== '/viewPdf'">
  <app-sidebar *ngIf="isSessionActive && loadedData"></app-sidebar>
  <router-outlet></router-outlet>
</main>
<main *ngIf="router.url === '/viewPdf'" class="pdfViewer">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
